var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27130",
    "data-name": "Group 27130",
    transform: "translate(20983 -5647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_medical_appointment_3149469",
    "data-name": "noun_medical appointment_3149469",
    transform: "translate(-20989.76 5641.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27124",
    "data-name": "Group 27124",
    transform: "translate(12.759 12.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45401",
    "data-name": "Path 45401",
    d: "M29.974,35.076H15.15a2.394,2.394,0,0,1-2.391-2.391V18.857a2.394,2.394,0,0,1,2.391-2.391h1.708v.8H15.15a1.593,1.593,0,0,0-1.592,1.591V32.685a1.593,1.593,0,0,0,1.592,1.591H29.974a1.593,1.593,0,0,0,1.592-1.591V18.857a1.593,1.593,0,0,0-1.592-1.591H28.287v-.8h1.687a2.394,2.394,0,0,1,2.391,2.391V32.685A2.394,2.394,0,0,1,29.974,35.076Z",
    transform: "translate(-12.759 -16.466)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27125",
    "data-name": "Group 27125",
    transform: "translate(18.414 12.508)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13385",
    "data-name": "Rectangle 13385",
    width: 7.861,
    height: 0.8,
    transform: "translate(0)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27126",
    "data-name": "Group 27126",
    transform: "translate(13.159 16.891)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13386",
    "data-name": "Rectangle 13386",
    width: 17.74,
    height: 0.8,
    transform: "translate(0 0)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27127",
    "data-name": "Group 27127",
    transform: "translate(16.36 11.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45402",
    "data-name": "Path 45402",
    d: "M28.046,14.5h-1.1a.639.639,0,0,1-.676-.61V11.68a.639.639,0,0,1,.676-.61h1.1a.639.639,0,0,1,.676.61v2.206A.639.639,0,0,1,28.046,14.5Zm-.977-.8h.854V11.87h-.854Z",
    transform: "translate(-26.269 -11.07)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27128",
    "data-name": "Group 27128",
    transform: "translate(25.985 11.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45403",
    "data-name": "Path 45403",
    d: "M64.152,14.5h-1.1a.639.639,0,0,1-.676-.61V11.68a.639.639,0,0,1,.676-.61h1.1a.639.639,0,0,1,.676.61v2.206A.639.639,0,0,1,64.152,14.5Zm-.977-.8h.854V11.87h-.854Z",
    transform: "translate(-62.375 -11.07)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_27129",
    "data-name": "Group 27129",
    transform: "translate(18.565 19.731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45404",
    "data-name": "Path 45404",
    d: "M40.2,51.805H37.121V49.223H34.539V46.144h2.582V43.562H40.2v2.582h2.582v3.078H40.2v2.582Zm-2.278-.8H39.4V48.423h2.582V46.944H39.4V44.362H37.921v2.582H35.339v1.479h2.582Z",
    transform: "translate(-34.539 -43.562)",
    fill: "#adadad",
    stroke: "#adadad",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointments);
export default __webpack_public_path__ + "static/media/Appointments.27d05038.svg";
export { ForwardRef as ReactComponent };